import { QueryHookOptions } from '@apollo/client';

import { PaginationInfo, usePaginatedQuery } from '@occc-app/hooks/usePaginatedQuery';
import {
  KioskDefaultScreenFilter,
  useKioskDefaultScreensQuery,
  KioskDefaultScreensQuery,
  KioskDefaultScreensQueryVariables,
  KioskDefaultScreenFragment,
} from '@occc/graphql';

type GetDefaultScreensProps = {
  filter: KioskDefaultScreenFilter;
  pageSize?: number;
  baseOptions?: QueryHookOptions<KioskDefaultScreensQuery, KioskDefaultScreensQueryVariables>;
  paginationInfo?: PaginationInfo;
  onPageChange?: (info: PaginationInfo) => void;
};

export const transformDataToDefaultScreensArray = (
  data?: KioskDefaultScreensQuery,
): KioskDefaultScreenFragment[] | undefined =>
  data?.kioskDefaultScreens?.edges?.map((e: { node: KioskDefaultScreenFragment }) => e.node);

export const useGetDefaultScreens = ({
  filter,
  pageSize,
  baseOptions,
  paginationInfo,
  onPageChange,
}: GetDefaultScreensProps) => {
  const response = usePaginatedQuery(
    useKioskDefaultScreensQuery,
    'kioskDefaultScreens.pageInfo',
    pageSize,
    {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      variables: {
        filter,
      },
      ...baseOptions,
    } as QueryHookOptions<KioskDefaultScreensQuery, KioskDefaultScreensQueryVariables>,
    paginationInfo,
    onPageChange,
  );

  return {
    ...response,
    data: transformDataToDefaultScreensArray(response.data),
  };
};
